import { Loader } from "@storybook";
import { useCallback, useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { SignInActiveStep, SignnPropsState } from "states";
import { SignIn } from "views";
import { FaceApiModels } from "views/face-auth/utils";

export const App = ({ ...props }) => {
  const { is_recipient, mobileNumber } = props;
  console.log("props ", mobileNumber, is_recipient);
  const [loading, setIsLoading] = useState(true);
  const handleOnLoadVideo = useCallback((event: any) => {
    setIsLoading(false);
  }, []);
  const signInActiveStep = useSetRecoilState(SignInActiveStep);
  const setSignnPropsState = useSetRecoilState(SignnPropsState);

  useEffect(() => {
    if (loading) {
      FaceApiModels.init();
      setSignnPropsState({ ...props });
    }

      signInActiveStep("chooseMethod");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_recipient, loading, signInActiveStep]);

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "grid",
            placeItems: "center",
            position: "absolute",
            inset: 0,
          }}
        >
          <Loader />
        </div>
      ) : (
        <SignIn
          {...props}
          isRecipient={is_recipient}
          isFaceOnly={props.face_recognition === "true"}
        />
      )}
      <video
        id="video"
        playsInline
        style={{ display: "none" }}
        onLoadStart={handleOnLoadVideo}
      ></video>
    </>
  );
};
